import { Button, ButtonProps } from "@chakra-ui/react"
import Link, { LinkProps } from "@pathwright/ux/src/components/link/Link"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { useLocation } from "react-router-dom"
import { usePathwrightContext } from "../pathwright/PathwrightContext"

export const DEFAULT_SIGN_IN_PATH = "/auth/sign-in/"

function buildSignInPath(next: string): string {
  return `/auth/sign-in?next=${encodeURIComponent(next)}`
}

type SignInLinkButtonProps = ButtonProps & {
  linkProps?: Omit<LinkProps, "to" | "children">
}

/** Augmentation-style Sign In control (Home popover, Cover Page, etc.). */
export function SignInLinkButton({
  linkProps,
  size = "sm",
  ...buttonProps
}: SignInLinkButtonProps) {
  const { me } = usePathwrightContext()
  const location = useLocation()
  const { t } = useTranslate()

  if (me) return null

  const next = `${location.pathname}${location.search}${location.hash}`
  const to = buildSignInPath(next)

  return (
    <Button
      asChild
      size={size}
      // @ts-expect-error: TODO: get typing correct using chakra typegen https://chakra-ui.com/docs/get-started/cli#chakra-typegen
      variant="blurredLightGray"
      {...buttonProps}
    >
      <Link variant="plain" textDecoration="none" to={to} {...linkProps}>
        <Pathicon icon="avatar-circle" />
        {t("nav.navbar_user.sign_in")}
      </Link>
    </Button>
  )
}

export default SignInLinkButton
